
import { defineComponent } from "vue";

export default defineComponent({
    name: "Message",
    props: {
        isError: Boolean,
        title: String,
        text: String,
        allowCopy: {
            type: Boolean,
            default: false
        },
        isCompliant: Boolean
    },
    emits: ["close"],
    data() {
        return {
            opacity: 0
        };
    },
    mounted() {
        this.opacity = 1;
    },

    methods: {
        hide() {
            this.opacitty = 0;
            window.setTimeout(() => {
                this.$emit("close");
            }, 500);
        },
        copyTextToCliboard(text: string) {
            console.log("copy text to clipboard");
            const copyText = document.createElement("textarea");
            document.body.appendChild(copyText);
            copyText.value = text;
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
            document.body.removeChild(copyText);
        }
    }
});
